import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Select from 'react-select'
import FilterPagination from 'pages/parts/FilterPagination'
import { Dropdown } from 'react-bootstrap'
import DatePicker from 'react-datepicker'

import { GET, httpOk } from 'helpers/api'
import { checkFilter, chequeDates, formatDate, formatMoney, getCurrentChequeDate } from 'helpers/helpers'
import { useNavigate } from 'react-router-dom'

function DocumentsPreparation() {
	const { t } = useTranslation()
	const navigate = useNavigate()

	const date = new Date()
	const initialFilter = {
		start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
		end_date: formatDate(new Date(), 'yyyy-MM-dd'),
		pos_id: null,
		search: ''
	};

	const [wmses, setWmses] = useState([])
	const [categories, setCategories] = useState([])
	const [products, setProducts] = useState([])
	const [data, setData] = useState([])

	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({ ...initialFilter })
	const [pagination, setPagination] = useState({
		url: `/shifts/`,
		response: null
	})

	function resetFilter() {
		setFilterData({ ...initialFilter })
	}

	async function selectChequeDates(option) {
		const result = getCurrentChequeDate(option.id)
		setFilterData({ ...filterData, ...result, 'dateType': option.id })
	}

	async function getData() {
		setFilterDataExist(checkFilter(filterData, initialFilter));

		const response = await GET("/report/documents-preparation", filterData, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'response': response.data })
			if (dropdownIsOpen) setDropdownIsOpen(false)
		}
	}

	async function paginate(page, size) {
		setFilterData({ ...filterData, 'page': page, 'size': size })
	}

	async function getWmses() {
		const response = await GET('/helper/wms')
		if (httpOk(response)) setWmses(response.data)
	}

	async function getCategories() {
		const response = await GET('/helper/categories')
		if (httpOk(response)) setCategories(response.data)
	}

	async function getProducts() {
		const response = await GET('/helper/all-products')
		if (httpOk(response)) setProducts(response.data)
	}

	useEffect(() => {
		getWmses()
		getCategories()
		getProducts()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		getData()
	}, [filterData.page, filterData.size]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('preparation')} [{data.total}]
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between align-items-center mb-3">
						<div className="d-flex gap-2">
							<div>
								<Dropdown onToggle={() => setDropdownIsOpen(!dropdownIsOpen)} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('warehouse')}</label>
												<Select
													options={wmses}
													value={wmses.find(option => option.id === filterData.dateType) || ''}
													onChange={(option) => setFilterData({ ...filterData, wms_id: option?.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
													isClearable
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('categories')}</label>
												<Select
													options={categories}
													value={categories.find(option => option.id === filterData.category_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, category_id: option?.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
													isClearable
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('products')}</label>
												<Select
													options={products}
													value={products.find(option => option.id === filterData.product_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, product_id: option?.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
													isClearable
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('grouping')}</label>
												<div className="form-check form-switch form-switch-lg m-2">
													<input type="checkbox" className="form-check-input"
														checked={filterData.group_by}
														onChange={(e) => setFilterData({ ...filterData, 'group_by': e.target.checked })} />
												</div>
											</div>

										</div>
										<div className="row">
											<div className="form-group col-md-4">
												<label>{t('period')}</label>
												<Select
													options={chequeDates}
													value={chequeDates.find(option => option.id === filterData.dateType) || ''}
													onChange={(option) => selectChequeDates(option)}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>

											<div className="form-group col-md-4">
												<label className="invisible">{t('period')}</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.start_date ? new Date(filterData.start_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'start_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
											<div className="form-group col-md-4">
												<label className="invisible">.</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.end_date ? new Date(filterData.end_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'end_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
										</div>

										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
													<button className="btn btn-primary" onClick={() => getData()}>{t('apply')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>

						<div>
							<h4>
								{t('amount')}: {formatMoney(data.total_amount)}
							</h4>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<span>|</span>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }}>#</th>
									{!filterData.group_by &&
										<th style={{ 'minWidth': '70px' }}>ID</th>
									}
									<th style={{ 'width': '10%' }} className="td-ellipsis">{t('warehouse')}</th>
									<th style={{ 'width': '20%' }}>{t('roll')}</th>
									<th style={{ 'width': '10%' }}>{t('roll')} ID</th>
									<th style={{ 'minWidth': '60px' }} className="text-end">{t('metr')}</th>
									<th style={{ 'width': '20%' }}>{t('name2')}</th>
									<th style={{ 'minWidth': '60px' }} className="text-end">{t('quantity')}</th>
									<th style={{ 'minWidth': '80px' }} className="text-end">{t('price')}</th>
									<th style={{ 'minWidth': '120px' }} className="text-center td-ellipsis">{t('date')}</th>
									<th style={{ 'minWidth': '100px' }} className="text-end">{t('amount')}</th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index} className={`${item.document_id ? "bg-on-hover" : ""}`} onClick={() => item.document_id ? navigate(`/documents-preparation/preview/${item.document_id}`) : ''}>
										<td>{item.row_number}</td>
										{!filterData.group_by &&
											<td>{item.document_id}</td>
										}
										<td>{item.wms_name}</td>
										<td className="td-ellipsis">{item.element_name}</td>
										<td className="td-ellipsis">{item.element_id}</td>
										<td className="text-end">{formatMoney(item.element_quantity, 2)}</td>
										<td className="td-ellipsis">{item.name}</td>
										<td className="text-end">{formatMoney(item.quantity, 2)}</td>
										<td className="text-end">{formatMoney(item.cost_price, 2)}</td>
										<td className="text-center">{formatDate(item.created_at, 'dd.MM.yyyy HH:mm')}</td>
										<td className="text-end">{formatMoney(item.quantity * item.cost_price, 2)}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>
		</>
	)
}

export default DocumentsPreparation